import React from 'react'
import EventCard, { EventWithAttendeesCount } from '../event-card/EventCard'
import CardGrid from '../../../../components/common/card-grid/CardGrid'

interface IEventGridProps {
  events: EventWithAttendeesCount[]
}

const EventGrid = ({ events }: IEventGridProps) => {
  return (
    <CardGrid
      cards={events.map((event) => (
        <EventCard event={event} key={event.id} />
      ))}
    />
  )
}

export default EventGrid
